import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function Community() {
    return (
        <Box
            id="community"
            sx={{
                width: '100%',
                backgroundColor: '#141414',
                pt: 6,
            }}
        >
            <Container maxWidth="lg">
                <Grid container alignItems="center" spacing={4}>
                    {/* Content Section */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ color: 'white', textAlign: 'left' }}>
                            {/* Subtitle */}
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: '#1e88e5', // Blue color for subtitle
                                    fontWeight: 'bold',
                                    mb: 1,
                                }}
                            >
                                Connect, Share, and Thrive
                            </Typography>

                            {/* Heading */}
                            <Typography
                                variant="h2"
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: '600',
                                    mb: 2,
                                }}
                            >
                                Join a Community of Innovators
                            </Typography>

                            {/* Paragraph */}
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 4,
                                }}
                            >
                                Become a part of a vibrant network of cybersecurity and cloud professionals. Collaborate, share insights, and learn
                                from the best in the industry. Our community fosters innovation and provides opportunities for growth through
                                peer engagement and knowledge sharing. Engage in thought-provoking discussions, participate in exclusive events,
                                and access cutting-edge resources tailored to your professional needs.
                            </Typography>
                            {/* Button */}
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                href="/community"
                            >
                                Learn More
                            </Button>
                        </Box>
                    </Grid>

                    {/* Image Section */}
                    <Grid item xs={12} sm={6}>
                        <Box
                            component="img"
                            src="/img/community.jpg" // Replace with actual image path
                            alt="Community Engagement"
                            sx={{
                                width: '100%',
                                borderRadius: 2,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
